import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito muchos seguidores?',
    a: 'No. Este plan funciona desde 0 seguidores porque usamos el algoritmo a tu favor.'
  }, {
    q: '¿Es apto para cualquier empresa de MLM?',
    a: 'Sí, el marketing de atracción es universal, sea salud, viajes o servicios.'
  }, {
    q: '¿Cuánto tiempo tardaré en ver resultados?',
    a: 'Si aplicas el Día 4 y 5 correctamente, empezarás a ver interacciones reales esa misma semana.'
  }, {
    q: '¿Tengo acceso de por vida?',
    a: 'Sí, el contenido es tuyo para siempre.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-darker px-6 py-20 md:py-28 border-t border-slate-800" data-id="element-37">
      <div className="mx-auto max-w-3xl" data-id="element-38">
        <div className="text-center mb-12" data-id="element-39">
          <div className="inline-flex items-center justify-center p-3 bg-brand-light rounded-full mb-4 border border-slate-700" data-id="element-40">
            <HelpCircle className="w-8 h-8 text-slate-300" data-id="element-41" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-42">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-43">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-light border border-slate-800 rounded-xl overflow-hidden" data-id="element-44">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-45">
                <span className="text-lg font-semibold text-white pr-4" data-id="element-46">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-47" />
              </button>

              <AnimatePresence data-id="element-48">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-49">
                    <div className="px-6 pb-5 text-slate-400 border-t border-slate-800/50 pt-4" data-id="element-50">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}